import { Cookies } from 'react-cookie';
import { ADD_TO_HOME_SCREEN_POP_UP_COOKIE_NAME } from '../../config';

export const setHideAddToHomeScreenPopUpCookie = hide =>
  new Cookies().set(ADD_TO_HOME_SCREEN_POP_UP_COOKIE_NAME, hide, {
    expires: new Date(new Date().setYear(2099)),
    path: '/',
  });
